import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { fetchInternalMfaStatus } from "../services/mfa.services";
import { InternalMfaStatus } from "../types/mfa";

export const internalMfaStatusQueryKey = ["internal-mfa-status"];

export function shouldRetryInternalMfaStatus(
    failureCount: number,
    error: AxiosError<IApiResponse<InternalMfaStatus>>
) {
    const status = error.response?.status;

    return failureCount < 1 && (!status || status >= 500);
}

export function useInternalMfaStatus(userId?: string) {
    return useQuery<
        InternalMfaStatus,
        AxiosError<IApiResponse<InternalMfaStatus>>
    >({
        queryKey: [...internalMfaStatusQueryKey, userId],
        queryFn: fetchInternalMfaStatus,
        enabled: Boolean(userId),
        retry: shouldRetryInternalMfaStatus,
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    });
}
